export default __webpack_public_path__ + "static/media/recurso_2.77b5ed57.png";